import React, {Component} from "react";
import {DateTime} from 'luxon';
import {Decimal} from 'decimal.js';
import Popup from 'reactjs-popup';

class RegistrationForm extends Component {
    constructor(props) {
        super(props);
        this.clickedSubmitButtonValue = null;

        this.state = {
            readOnlyForm: false,
            approvalStatus: "",
            paymentStatus: this.props.settings.paymentStatusUnpaid,
            studentId: "",
            branchId: "",
            branchLabel: "",
            ageGroupId: "",
            ageGroupLabel: "",
            courseCategoryId: "",
            courseCategoryLabel: "",
            courses: [],
            courseId: "",
            courseLabel: "",
            coursePrice: "",
            coursePriceCurrency: "",
            courseDiscountedPrice: "",
            courseTimes: [],
            courseTime: null,
            courseTimeId: "",
            spinnerStyle: {visibility: 'hidden'},
            errorMessage: "",
            studentIdCheckCurrentAjax: null,
            studentIdCheckAjaxSetTimeout: null,
            studentIdIsValid: false,
            studentIdIsInvalid: false,
            studentName: "",
            studentBirthdate: "",
            studentEmail: "",
            studentPhone: "",
            discountCode: "",
            appliedDiscountCode: "",
            appliedDiscountType: "",
            appliedDiscountAmount: 0,
            termsPopUpOpen: false,
            disableAcceptTermsButton: true,
            termsAccepted: false
        };

        if (this.props.load) {
            this.state = window.jQuery.extend(this.state, this.props.load);

            if (this.state.appliedDiscountCode) {
                this.calculateCourseDiscountedPrice(
                    this.state,
                    this.state.appliedDiscountCode,
                    this.state.appliedDiscountType,
                    this.state.appliedDiscountAmount)
            }
        }
    }

    isAjaxInProgress = () => {
        return this.state.spinnerStyle.visibility === 'visible';
    }

    signalAjaxEnd = (state, callback) => {
        this.setState(window.jQuery.extend({spinnerStyle: {visibility: 'hidden'}}, state), callback);
    }

    signalAjaxStart = (state, callback) => {
        this.setState(
            window.jQuery.extend({spinnerStyle: {visibility: 'visible'}, hasAjaxFailed: false}, state),
            callback);
    }

    handleStudentIdChange = (event) => {
        const target = event.target;
        if (this.state.studentIdCheckAjaxSetTimeout) {
            clearTimeout(this.state.studentIdCheckAjaxSetTimeout);
        }

        if (!event.target.value) {
            this.setState({
                studentIdIsValid: false,
                studentIdIsInvalid: false,
                studentId: ""
            });
            return;
        }

        this.setState({
            studentIdIsValid: false,
            studentIdIsInvalid: false,
            studentId: target.value
        }, () => {
            this.setState({
                studentIdCheckAjaxSetTimeout: setTimeout(async () => {
                    this.signalAjaxStart();
                    let suppressAjaxEnd = false;
                    const resultState = {studentIdIsValid: false, studentIdIsInvalid: false};
                    try {
                        if (this.state.studentIdCheckCurrentAjax) {
                            this.state.studentIdCheckCurrentAjax.abort();
                        }

                        const ajaxRequest = window.jQuery.ajax({
                            method: "POST",
                            url: this.props.settings.ajaxUrl,
                            dataType: "json",
                            data: {
                                action: this.props.settings.actionStudentIdCheck,
                                "_wpnonce": this.props.settings.nonceStudentIdCheck,
                                student_id_slug: target.value
                            }
                        });
                        this.setState({studentIdCheckCurrentAjax: ajaxRequest});
                        const result = await ajaxRequest;

                        if (result) {
                            resultState.studentIdIsValid = true;
                        } else {
                            resultState.studentIdIsInvalid = true;
                        }
                    } catch (error) {
                        if (error.status !== 0) {
                            resultState.errorMessage = this.props.l10n.messageError;
                            console.log(error);
                        } else {
                            suppressAjaxEnd = true;
                        }
                    } finally {
                        if (!suppressAjaxEnd) {
                            this.signalAjaxEnd(resultState);
                        }
                    }
                }, 250)
            });
        });
    }

    handleBranchIdChange = (event) => {
        let branchLabel = "";
        for (let i = 0; i < this.props.settings.branches.length; i++) {
            const branch = this.props.settings.branches[i];
            if (branch.value === event.target.value) {
                branchLabel = branch.label;
                break;
            }
        }

        this.setState({branchId: event.target.value, branchLabel: branchLabel}, async () => {
            await this.maybeUpdateCourseTimeList();
        });
    }

    handleAgeGroupIdChange = (event) => {
        let ageGroupLabel = "";
        for (let i = 0; i < this.props.settings.ageGroups.length; i++) {
            const ageGroup = this.props.settings.ageGroups[i];
            if (ageGroup.value === event.target.value) {
                ageGroupLabel = ageGroup.label;
                break;
            }
        }

        let resultState = {
            ageGroupId: event.target.value,
            ageGroupLabel: ageGroupLabel,
            courseCategoryId: "",
            courseCategoryLabel: ""
        };

        if ((this.props.settings.courseCategories[event.target.value] || []).length === 1) {
            resultState.courseCategoryId = this.props.settings.courseCategories[event.target.value][0].value;
        }

        this.setState(resultState, async () => {
            await this.maybeUpdateCourseList();
        });
    }

    handleCourseCategoryIdChange = (event) => {
        let courseCategoryLabel = "";
        for (let i = 0; i < this.props.settings.courseCategories[this.state.ageGroupId].length; i++) {
            const courseCategory = this.props.settings.courseCategories[this.state.ageGroupId][i];
            if (courseCategory.value === event.target.value) {
                courseCategoryLabel = courseCategory.label;
                break;
            }
        }

        this.setState({
            courseCategoryId: event.target.value,
            courseCategoryLabel: courseCategoryLabel
        }, async () => {
            await this.maybeUpdateCourseList();
        });
    }

    handleCourseIdChange = (event) => {
        let courseLabel = "";
        for (let i = 0; i < this.state.courses.length; i++) {
            const course = this.state.courses[i];
            if (course.value === event.target.value) {
                courseLabel = course.label;
                break;
            }
        }

        this.setState({
            courseId: event.target.value,
            courseLabel: courseLabel,
            }, async () => {
            await this.maybeUpdateCourseTimeList();
        });
    }

    isFormIncomplete = () => {
        return this.state.branchId.length === 0
            || this.state.courseId.length === 0
            || this.state.courseTimeId.length === 0
            || this.state.studentName.length === 0
            || this.state.studentBirthdate.length === 0
            || this.state.studentEmail.length === 0
            || this.state.studentPhone.length === 0;
    }

    maybeUpdateCourseList = async () => {
        const resultState = {errorMessage: "", courses: [], courseId: ""};
        if (!this.state.ageGroupId || !this.state.courseCategoryId) {
            this.setState(resultState, async () => {
                await this.maybeUpdateCourseTimeList();
            });
            return;
        }

        this.signalAjaxStart();
        try {
            resultState.courses = await window.jQuery.ajax({
                method: "POST",
                url: this.props.settings.ajaxUrl,
                dataType: "json",
                data: {
                    action: this.props.settings.actionCourseLookup,
                    "_wpnonce": this.props.settings.nonceCourseLookup,
                    branch_id: this.state.branchId,
                    course_category_id: this.state.courseCategoryId
                }
            });
            if (resultState.courses.length === 0) {
                resultState.errorMessage = this.props.l10n.messageErrorNoCoursesFound;
            }
        } catch (error) {
            resultState.errorMessage = this.props.l10n.amessageError;
            console.log(error);
        } finally {
            this.signalAjaxEnd(resultState, async () => {
                await this.maybeUpdateCourseTimeList();
            });
        }
    }

    maybeUpdateCourseTimeList = async () => {
        const resultState = {courseTimes: [], courseTimeId: ""};
        if (!this.state.courseId || !this.state.branchId) {
            this.setState(resultState);
            return;
        }

        resultState.errorMessage = "";

        this.signalAjaxStart();
        try {
            resultState.courseTimes = await window.jQuery.ajax({
                method: "POST",
                url: this.props.settings.ajaxUrl,
                dataType: "json",
                data: {
                    action: this.props.settings.actionCourseTimeLookup,
                    "_wpnonce": this.props.settings.nonceCourseTimeLookup,
                    course_category_id: this.state.courseCategoryId,
                    course_id: this.state.courseId,
                    branch_id: this.state.branchId
                }
            });
            if (resultState.courseTimes.length === 0) {
                resultState.errorMessage = this.props.l10n.messageErrorNoCourseTimesFound;
            }
        } catch (error) {
            resultState.errorMessage = this.props.l10n.messageError;
            console.log(error);
        } finally {
            this.signalAjaxEnd(resultState);
        }
    }

    handleCourseTimetableEntryIdChange = (event) => {
        let courseTimeDetails = "";
        for (let i = 0; i < this.state.courseTimes.length; i++) {
            const courseTime = this.state.courseTimes[i];
            if (courseTime.id === event.target.value) {
                courseTimeDetails = courseTime;
                break;
            }
        }

        this.setState({
            courseTimeId: event.target.value,
            courseTime: courseTimeDetails,
            coursePrice: courseTimeDetails.coursePrice,
            coursePriceCurrency: courseTimeDetails.coursePriceCurrency
        });
    }

    handleStudentNameChange = (event) => {
        this.setState({studentName: event.target.value});
    }

    handleStudentBirthdateChange = (event) => {
        this.setState({studentBirthdate: event.target.value});
    }

    handleStudentEmailChange = (event) => {
        this.setState({studentEmail: event.target.value});
    }

    handleStudentPhoneChange = (event) => {
        this.setState({studentPhone: event.target.value});
    }

    handleDiscountCodeChange = (event) => {
        this.setState({discountCode: event.target.value, errorMessage: ""});
    }

    handleDiscountCodeKeypress = (event) => {
        if (event.charCode === 13) {
            this.handleApplyDiscountClick().then(() => {
            });
            event.preventDefault();
        }
    }

    handleApplyDiscountClick = async () => {
        const resultState = {
            appliedDiscountCode: "",
            appliedDiscountType: "",
            appliedDiscountAmount: 0,
            courseDiscountedPrice: "",
            errorMessage: ""
        };
        this.signalAjaxStart(resultState, async () => {
            try {
                const discountCodeDetails = await window.jQuery.ajax({
                    method: "POST",
                    url: this.props.settings.ajaxUrl,
                    dataType: "json",
                    data: {
                        action: this.props.settings.actionDiscountCodeLookup,
                        "_wpnonce": this.props.settings.nonceDiscountCodeLookup,
                        discount_code: this.state.discountCode
                    }
                });

                if (discountCodeDetails.id !== null) {
                    this.calculateCourseDiscountedPrice(
                        resultState,
                        discountCodeDetails.discountCode,
                        discountCodeDetails.discountType,
                        discountCodeDetails.discountAmount);
                } else {
                    resultState.errorMessage = this.props.l10n.messageInvalidDiscountCode;
                }
            } catch (error) {
                resultState.errorMessage = this.props.l10n.messageError;
                console.log(error);
            } finally {
                this.signalAjaxEnd(resultState);
            }
        });
    }

    calculateCourseDiscountedPrice = (resultState, discountCode, discountType, discountAmount) => {
        resultState.appliedDiscountCode = discountCode;
        resultState.appliedDiscountType = discountType;
        resultState.appliedDiscountAmount = discountAmount;

        let coursePrice = new Decimal(this.state.coursePrice);
        let discountAmountDecimal = new Decimal(discountAmount || "0");
        if (discountType === this.props.settings.discountTypeCurrency) {
            coursePrice = Decimal.max(0, coursePrice.minus(discountAmountDecimal));
        } else if (discountType === this.props.settings.discountTypePercentage) {
            coursePrice = coursePrice.times((new Decimal(100)).minus(discountAmountDecimal)).dividedToIntegerBy(100);
        }
        resultState.courseDiscountedPrice = coursePrice.toString();
    }

    handleClearDiscountCodeClick = (event) => {
        this.setState({
            appliedDiscountCode: "",
            appliedDiscountType: "",
            appliedDiscountAmount: 0,
            courseDiscountedPrice: "",
            errorMessage: ""
        });
        event.preventDefault();
    }

    handleSubmitRegister = (event) => {
        event.preventDefault();

        if (!this.state.termsAccepted) {
            this.setState({ termsPopUpOpen: true });
            return;
        }

        const resultState = {errorMessage: ""};
        this.signalAjaxStart(null, async () => {
            try {
                const result = await window.jQuery.ajax({
                    method: "POST",
                    url: this.props.settings.ajaxUrl,
                    dataType: "json",
                    data: {
                        action: this.props.settings.actionRegisterForCourse,
                        "_wpnonce": this.props.settings.nonceRegisterForCourse,
                        student_id: this.state.studentId,
                        branch_id: this.state.branchId,
                        timetable_entry_id: this.state.courseTimeId,
                        student_name: this.state.studentName,
                        student_birthdate: this.state.studentBirthdate,
                        student_email: this.state.studentEmail,
                        student_phone: this.state.studentPhone,
                        discount_code: this.state.appliedDiscountCode,
                        last_seen_course_price: this.state.coursePrice,
                        last_seen_discount_type: this.state.appliedDiscountType,
                        last_seen_discount_amount: this.state.appliedDiscountAmount,
                        terms_accepted: this.state.termsAccepted
                    }
                });

                if (result.success) {
                    let href = window.location.href;
                    const indexOfQuestionMark = href.indexOf("?");
                    if (indexOfQuestionMark <= 0) {
                        href += "?";
                    } else if (!window.location.href.endsWith("?")) {
                        href += "&";
                    }
                    href += "wpcr_registration_form_id="
                    href += encodeURIComponent(result.registration_id);
                    href += "&wpcr_registration_form_access_key="
                    href += encodeURIComponent(result.access_key);

                    window.location.href = href;
                } else if (!result.cancelled) {
                    resultState.errorMessage = this.props.l10n.messageError;
                }
            } catch (error) {
                if (error.status === 422) {
                    if (error.responseJSON.error === this.props.settings.errorInvalidStudentId) {
                        resultState.errorMessage = this.props.l10n.messageErrorInvalidStudentId;
                    } else if (error.responseJSON.error === this.props.settings.errorInvalidBranchId) {
                        resultState.errorMessage = this.props.l10n.messageErrorInvalidBranchId;
                    } else if (error.responseJSON.error === this.props.settings.errorTimetableEntryId) {
                        resultState.errorMessage = this.props.l10n.messageErrorInvalidTimetableEntryId;
                    } else if (error.responseJSON.error === this.props.settings.errorCourseTimeNoLongerAvailable) {
                        resultState.errorMessage = this.props.l10n.messageErrorCourseTimeNoLongerAvailable;
                    } else if (error.responseJSON.error === this.props.settings.errorCoursePriceChanged) {
                        resultState.errorMessage = this.props.l10n.messageErrorCoursePriceChanged;
                    } else if (error.responseJSON.error === this.props.settings.errorInvalidStudentBirthdate) {
                        resultState.errorMessage = this.props.l10n.messageErrorInvalidStudentBirthdate;
                    } else if (error.responseJSON.error === this.props.settings.errorInvalidDiscountCode) {
                        resultState.errorMessage = this.props.l10n.messageErrorInvalidDiscountCode;
                    } else if (error.responseJSON.error === this.props.settings.errorDiscountCodeChanged) {
                        resultState.errorMessage = this.props.l10n.messageErrorDiscountCodeChanged;
                    } else {
                        resultState.errorMessage = this.props.l10n.messageErrorSelectionsNoLongerValid;
                    }
                    return;
                }
                resultState.errorMessage = this.props.l10n.messageError;
            } finally {
                this.signalAjaxEnd(resultState);
            }
        });
    }

    handleSubmitPay = (event) => {
        event.preventDefault();

        this.signalAjaxStart({readOnlyForm: true, errorMessage: ""}, async () => {
            const resultState = {errorMessage: ""};
            const paymentGatewayId = this.props.settings.paymentGatewayId;
            const paymentFunction = window.wpcrPaymentGateways[paymentGatewayId];
            const urlParams = new URLSearchParams(window.location.search);
            const courseTime = this.state.courseTime;
            const courseDescription = `${this.state.branchLabel} - ${this.state.courseLabel} - ${courseTime.weekdays.join(" & ")} - ${DateTime.fromISO(courseTime.startTime).setLocale(this.props.l10n.locale).toLocaleString(DateTime.TIME_24_SIMPLE)}-${DateTime.fromISO(courseTime.endTime).setLocale(this.props.l10n.locale).toLocaleString(DateTime.TIME_24_SIMPLE)} - ${DateTime.fromISO(courseTime.startDate).setLocale(this.props.l10n.locale).toLocaleString(DateTime.DATE_FULL)} - ${courseTime.durationWeeks} ${this.props.l10n.weeks}`;

            try {
                let executionResult = paymentFunction(
                    urlParams.get("wpcr_registration_form_id"),
                    this.state.studentName,
                    this.state.studentEmail,
                    courseDescription,
                    this.state.appliedDiscountCode ? this.state.courseDiscountedPrice : this.state.coursePrice,
                    this.props.settings.currency);
                if (executionResult && executionResult.then) {
                    executionResult = await executionResult;
                }

                if (executionResult.cancelled) {
                    console.log("Payment cancelled by user.");
                    resultState.errorMessage = this.props.l10n.messageErrorPaymentGatewayCancelled;
                    return;
                }

                console.log("Payment result:");
                console.log(executionResult);
                window.location.reload();
            } catch (error) {
                resultState.errorMessage = this.props.l10n.messageErrorPaymentGateway;

                if (typeof error === "string") {
                    resultState.errorMessage = this.props.l10n.messageErrorPaymentGatewayWithMessage + error;
                }

                console.log(error);
            } finally {
                this.signalAjaxEnd(resultState);
            }
        });
    }

    handleSubmitClick = (event) => {
        this.clickedSubmitButtonValue = event.target.value;
    };

    handleTermsPopUpClose = (event) => {
        this.setState({termsPopUpOpen: false, disableAcceptTermsButton: true});
    }

    handleTermsIframeLoad = (event) => {
        const iframe = event.target;
        const doc = iframe.contentWindow;
        const self = this;

        doc.addEventListener('scroll', () => {
            if (window.jQuery(doc).scrollTop() + window.jQuery(doc).height() > window.jQuery(doc.document).innerHeight() - 100) {
                self.setState({disableAcceptTermsButton: false});
            }
        });
    }

    handleAcceptTermsClick = (event) => {
        this.setState({
            termsAccepted: true,
            termsPopUpOpen: false
        }, function() {
            this.handleSubmitRegister(event);
        });
    }

    handleFormSubmit = (event) => {
        let eventHandler;
        if (this.clickedSubmitButtonValue === this.props.l10n.buttonRegisterForCourse) {
            eventHandler = this.handleSubmitRegister;
        } else if (this.clickedSubmitButtonValue === this.props.l10n.buttonPayForCourse) {
            eventHandler = this.handleSubmitPay;
        }

        this.setState({clickedSubmitButtonValue: null});
        if (eventHandler) {
            eventHandler(event);
        }
        event.preventDefault();
    }

    render = () => {
        return (
            <form className="wpcr-registration-form" onSubmit={this.handleFormSubmit}>
                <section className="main-form">
                    <header>
                        <h2>{this.props.l10n.titleForm}</h2>
                        <span className="spinner" style={this.state.spinnerStyle}/>
                    </header>
                    {this.props.settings.noticeMessage && (
                        <div className="notice">
                            <p>{this.props.settings.noticeMessage}</p>
                        </div>
                    )}
                    {this.state.noticeMessage && (
                        <div className="notice">
                            <p>{this.state.noticeMessage}</p>
                        </div>
                    )}
                    {this.state.errorMessage && (
                        <div className="error">
                            <p>{this.state.errorMessage}</p>
                        </div>
                    )}
                    <section className="course-information">
                        <div className="form-group">
                            <label htmlFor="student_id">{this.props.l10n.labelStudentID}</label>
                            <input type="text" name="student_id" id="student_id"
                                   value={this.state.studentId}
                                   onChange={this.handleStudentIdChange}
                                   readOnly={this.state.readOnlyForm}
                                   required={true}/>
                            <div className="student-id-validation">
                                {this.state.studentIdIsValid && (
                                    <span className="student-id-valid">
                                        {this.props.l10n.messageStudentIDValid}
                                    </span>
                                )}
                                {this.state.studentIdIsInvalid && (
                                    <span className="student-id-invalid">
                                        {this.props.l10n.messageStudentIDInvalid}
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="branch_id">{this.props.l10n.labelBranch}</label>
                            <select name="branch_id"
                                    id="branch_id"
                                    value={this.state.branchId}
                                    onChange={this.handleBranchIdChange}
                                    disabled={this.state.readOnlyForm}
                                    required={true}>
                                <option value="">{this.props.l10n.labelSelect}</option>
                                {this.props.settings.branches.map((item, _) => {
                                    return (
                                        <option key={item.value} value={item.value}>{item.label}</option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>{this.props.l10n.labelAgeGroup}</label>
                            <div className="form-input">
                                {this.props.settings.ageGroups.map((item, _) => {
                                    return (
                                        <label key={item.value}>
                                            <input type="radio" name="age_group" value={item.value}
                                                   onChange={this.handleAgeGroupIdChange}
                                                   checked={item.value === this.state.ageGroupId}
                                                   disabled={this.state.readOnlyForm || this.isAjaxInProgress()}
                                                   required={true}/>&nbsp;
                                            {item.label}
                                        </label>
                                    );
                                })}
                            </div>
                        </div>
                        {this.state.branchId.length > 0 && this.state.ageGroupId.length > 0 && (
                            <div className="form-meta-group">
                                {(this.props.settings.courseCategories[this.state.ageGroupId] || []).length > 1 && (
                                    <div className="form-group">
                                        <label
                                            htmlFor="course_category_id">{this.props.l10n.labelCourseCategory}</label>
                                        <select name="course_category_id"
                                                id="course_category_id"
                                                value={this.state.courseCategoryId}
                                                required={true}
                                                onChange={this.handleCourseCategoryIdChange}
                                                disabled={this.state.readOnlyForm || this.isAjaxInProgress()}>
                                            <option value="">{this.props.l10n.labelSelect}</option>
                                            {this.props.settings.courseCategories[this.state.ageGroupId].map((item, _) => {
                                                return (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                )}
                                <div className="form-group">
                                    <label htmlFor="course_id">{this.props.l10n.labelCourse}</label>
                                    <select name="course_id"
                                            id="course_id"
                                            value={this.state.courseId}
                                            onChange={this.handleCourseIdChange}
                                            required={true}
                                            disabled={this.state.readOnlyForm || this.isAjaxInProgress()}>
                                        <option value="">{this.props.l10n.labelSelect}</option>
                                        {this.state.courses.map((item, _) => {
                                            return (
                                                <option key={item.value} value={item.value}>{item.label}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                        )}
                        {this.state.courseTimes.length > 0 && (
                            <div className="form-group">
                                <label>{this.props.l10n.labelCourseTime}</label>
                                <ul className="course-times-container">
                                    {this.state.courseTimes.map((item, _) => {
                                        return (
                                            <li>
                                                <label key={item.id}>
                                                    <input type="radio" name="course_time_table_entry_id"
                                                           value={item.id}
                                                           checked={item.id === this.state.courseTimeId}
                                                           disabled={this.state.readOnlyForm || this.isAjaxInProgress()}
                                                           required={true}
                                                           onChange={this.handleCourseTimetableEntryIdChange}/>&nbsp;
                                                    <span>
                                                        {item.weekdays.join(" & ")} -&nbsp;
                                                        {DateTime.fromISO(item.startTime).setLocale(this.props.l10n.locale).toLocaleString(DateTime.TIME_24_SIMPLE)}-{DateTime.fromISO(item.endTime).setLocale(this.props.l10n.locale).toLocaleString(DateTime.TIME_24_SIMPLE)} -&nbsp;
                                                        {DateTime.fromISO(item.startDate).setLocale(this.props.l10n.locale).toLocaleString(DateTime.DATE_FULL)} -&nbsp;
                                                        {item.durationWeeks} {this.props.l10n.weeks}
                                                    </span>
                                                </label>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        )}
                    </section>
                    <h3>{this.props.l10n.headingStudentInformation}</h3>
                    <div className="form-meta-group">
                        <div className="form-group">
                            <label htmlFor="student_name">{this.props.l10n.labelName}</label>
                            <input type="text" name="student_name" id="student_name"
                                   onChange={this.handleStudentNameChange}
                                   value={this.state.studentName}
                                   readOnly={this.state.readOnlyForm}
                                   required={true}/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="student_birthdate">{this.props.l10n.labelBirthdate}</label>
                            <input type="date" name="student_birthdate" id="student_birthdate"
                                   onChange={this.handleStudentBirthdateChange}
                                   value={this.state.studentBirthdate}
                                   readOnly={this.state.readOnlyForm}
                                   required={true}/>
                        </div>
                    </div>
                    <div className="form-meta-group">
                        <div className="form-group">
                            <label htmlFor="student_email">{this.props.l10n.labelEmail}</label>
                            <input type="email" name="student_email" id="student_email"
                                   onChange={this.handleStudentEmailChange}
                                   value={this.state.studentEmail}
                                   readOnly={this.state.readOnlyForm}
                                   required={true}/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="student_phone">{this.props.l10n.labelPhone}</label>
                            <input type="tel" name="student_phone" id="student_phone"
                                   onChange={this.handleStudentPhoneChange}
                                   value={this.state.studentPhone}
                                   readOnly={this.state.readOnlyForm}
                                   required={true}/>
                        </div>
                    </div>
                </section>
                <section className="side-panel">
                    <h3>{this.props.l10n.headingPaymentInformation}</h3>
                    {this.isFormIncomplete() && (
                        <p>{this.props.l10n.messageCompleteFormFirst}</p>
                    )}
                    {!this.isFormIncomplete() && (
                        <div className="course-registration-summary">
                            <div className="branch-course-summary">
                                <strong>{this.state.branchLabel}</strong><br/>
                                <strong>{this.state.courseLabel}</strong>
                            </div>
                            <div className="course-time-summary">
                                {this.state.ageGroupLabel}{this.state.courseCategoryLabel && (
                                <span> - {this.state.courseCategoryLabel}</span>)}<br/>
                                {this.state.courseTime.weekdays.join(" & ")}<br/>
                                {DateTime.fromISO(this.state.courseTime.startTime).setLocale(this.props.l10n.locale).toLocaleString(DateTime.TIME_24_SIMPLE)}-{DateTime.fromISO(this.state.courseTime.endTime).setLocale(this.props.l10n.locale).toLocaleString(DateTime.TIME_24_SIMPLE)}<br/>
                                {DateTime.fromISO(this.state.courseTime.startDate).setLocale(this.props.l10n.locale).toLocaleString(DateTime.DATE_FULL)} - {this.state.courseTime.durationWeeks} {this.props.l10n.weeks}
                            </div>
                            <h4 className="price-display">
                                {!this.state.appliedDiscountCode && (
                                    <span>
                                        {this.state.coursePriceCurrency} {new Decimal(this.state.coursePrice).toLocaleString()}
                                    </span>
                                )}
                                {this.state.appliedDiscountCode && (
                                    <span>
                                        <s>{this.state.coursePriceCurrency} {new Decimal(this.state.coursePrice).toLocaleString()}</s><br/>
                                        <span
                                            class="discounted-price">{this.state.coursePriceCurrency} {new Decimal(this.state.courseDiscountedPrice).toLocaleString()}</span>
                                    </span>
                                )}
                            </h4>
                            {!this.state.appliedDiscountCode && !this.state.readOnlyForm && (
                                <div className="discount-code-input">
                                    <h5>{this.props.l10n.labelDoYouHaveADiscountCode}</h5>
                                    <div className="form-group">
                                        <input type="text" name="discount_code"
                                               placeholder={this.props.l10n.placeholderDiscountCode}
                                               disabled={this.isAjaxInProgress()}
                                               onChange={this.handleDiscountCodeChange}
                                               onKeyPress={this.handleDiscountCodeKeypress}/>
                                        <input type="button" value={this.props.l10n.buttonApply}
                                               onClick={this.handleApplyDiscountClick}
                                               disabled={this.isAjaxInProgress()}/>
                                    </div>
                                </div>
                            )}
                            {this.state.appliedDiscountCode && (
                                <p className="applied-discount-code">
                                    {this.props.l10n.messageAppliedDiscountCode}
                                    <strong>{this.state.appliedDiscountCode}</strong>&nbsp;
                                    {!this.state.readOnlyForm && (
                                        /* eslint-disable-next-line */
                                        <span>(<a href="#"
                                                  onClick={this.handleClearDiscountCodeClick}>{this.props.l10n.linkClearDiscountCode}</a>)</span>
                                    )}
                                    <input type="hidden" name="discount_code" value={this.state.appliedDiscountCode}/>
                                </p>
                            )}
                            <div className="submit-input">
                                {this.state.approvalStatus === "" && this.state.paymentStatus === this.props.settings.paymentStatusUnpaid && (
                                    <input type="submit" value={this.props.l10n.buttonRegisterForCourse}
                                           onClick={this.handleSubmitClick}
                                           disabled={this.isAjaxInProgress()}/>
                                )}
                                {this.state.approvalStatus === this.props.settings.approvalStatusApproved && this.state.paymentStatus === this.props.settings.paymentStatusUnpaid && (
                                    <input type="submit" value={this.props.l10n.buttonPayForCourse}
                                           onClick={this.handleSubmitClick}
                                           disabled={this.isAjaxInProgress()}/>
                                )}
                            </div>
                        </div>
                    )}
                </section>
                <Popup open={this.state.termsPopUpOpen} closeOnDocumentClick onClose={this.handleTermsPopUpClose}>
                    <div className="modal">
                        {/* eslint-disable-next-line */}
                        <a className="close" onClick={this.handleTermsPopUpClose}>
                            &times;
                        </a>
                        <div class="modal-content">
                            <iframe src={this.props.settings.termsAndConditionsUrl} onLoad={this.handleTermsIframeLoad} title={this.props.l10n.labelTermsAndConditions} />
                            <button class="accept-terms-button" onClick={this.handleAcceptTermsClick} disabled={this.state.disableAcceptTermsButton}>
                                {this.props.l10n.labelIAcceptTermsAndConditions}
                            </button>
                        </div>
                    </div>
                </Popup>
            </form>
        );
    }
}

export default RegistrationForm;
